import React from 'react';

import { ErrorPage } from 'src/pages/ErrorPage';

export const NoMatch = () => (
  <ErrorPage message="We couldn’t find the page you were looking for." />
);
